// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.defect-colors {\n  display: inline-block;\n  margin-right: 10px;\n  font-weight: bold;\n  margin-left: 2px;\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
